export default class OrderAmendStatus {
  constructor(order, status, userId) {
    this.orderId = order.id;
    this.status = status;
    this.userId = userId;
    this.user = userId;
  }
}
